import { Utils } from "./utils";// TODO: use AWS SDK instead

const profile = {
    userPoolDomain: 'lisamanager', // Replace with your User Pool ID
    clientId: '5f910e49klcnvji6tavktthnc3', // Replace with your User Pool Client ID
    region: 'eu-west-2', // Replace with your AWS region
    redirectUri: 'https://lisamanager.com'
};

export class Cognito {
    // Function to construct Hosted UI URLs
    public url(action: string): string {
        const baseUrl = `https://${profile.userPoolDomain}.auth.${profile.region}.amazoncognito.com`;
        const url = `${baseUrl}/${action}?client_id=${profile.clientId}&response_type=code&redirect_uri=${profile.redirectUri}`;
        switch (action) {
            case 'login':
            case 'signup':
                return `${url}&scope=email+openid`;
            case 'logout':
                return `${url}&logout_uri=${profile.redirectUri}`;
            default:
                throw new Error('Invalid action for Hosted UI URL');
        }
    }

    public async convertToToken(code: string): Promise<string> {
        try {
            Utils.showLoader();
            const tokenEndpoint = `https://${profile.userPoolDomain}.auth.${profile.region}.amazoncognito.com/oauth2/token`;

            const response = await fetch(tokenEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    grant_type: 'authorization_code',
                    client_id: profile.clientId,
                    code: code,
                    redirect_uri: profile.redirectUri
                }).toString()
            });

            if (!response.ok)
                throw new Error(`HTTP error! status: ${response.status}`);

            const data = await response.json();
            if (!data.id_token)
                throw new Error('No token received in response');

            localStorage.setItem('jwt', data.id_token);
            // Keep the refresh token so the session can be renewed silently (see refresh()).
            if (data.refresh_token)
                localStorage.setItem('refresh_token', data.refresh_token);
            return data.id_token;

        } catch (error) {
            console.error('Failed to convert authorization code to token:', error);
            throw error; // Re-throw to allow handling by caller
        } finally {
            Utils.hideLoader();
        }
    }

    /**
     * Silently mint a fresh id token from the stored refresh token (no user
     * interaction). Cognito returns a new id/access token but reuses the same
     * refresh token, so we only persist the new id token. Throws if no refresh
     * token is stored or the grant is rejected (e.g. refresh token expired).
     */
    public async refresh(): Promise<string> {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken)
            throw new Error('No refresh token available');

        const tokenEndpoint = `https://${profile.userPoolDomain}.auth.${profile.region}.amazoncognito.com/oauth2/token`;
        const response = await fetch(tokenEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                grant_type: 'refresh_token',
                client_id: profile.clientId,
                refresh_token: refreshToken,
            }).toString()
        });

        if (!response.ok)
            throw new Error(`Token refresh failed: ${response.status}`);

        const data = await response.json();
        if (!data.id_token)
            throw new Error('No id_token in refresh response');

        localStorage.setItem('jwt', data.id_token);
        return data.id_token;
    }

    /**
     * Log out: best-effort revoke of the refresh token at Cognito (invalidates it
     * and tokens derived from it server-side, so a leaked copy is useless), then
     * clear all stored auth state. Revoke failure is non-fatal — we still wipe
     * local state. `keepalive` lets the revoke complete even if the page navigates.
     */
    public async logout(): Promise<void> {
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
            try {
                const revokeEndpoint = `https://${profile.userPoolDomain}.auth.${profile.region}.amazoncognito.com/oauth2/revoke`;
                await fetch(revokeEndpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    keepalive: true,
                    body: new URLSearchParams({
                        token: refreshToken,
                        client_id: profile.clientId,
                    }).toString()
                });
            } catch (error) {
                console.error('Refresh token revoke failed (clearing local state anyway):', error);
            }
        }
        localStorage.removeItem('jwt');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('hmrc_state');
    }
}